<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <p class="font18bold breadcrums">
            <router-link to="/">Home</router-link> |
            <router-link to="/recipes">Recipes</router-link> |
            <router-link to="#">details </router-link>
        </p>
        <b-row class="desktop">
            <b-col cols="12" md="3">
                <RecipeSidebar class="mt-5" recipes='active' />
            </b-col>
            <b-col cols="12" md="9" class="mt-5">
                <div v-if="loading">
                    <content-loader :speed="2" :height="400" :width="700">
                        <rect x="4" y="8" rx="3" ry="3" width="7" height="288" />
                        <rect x="6" y="289" rx="3" ry="3" width="669" height="8" />
                        <rect x="670" y="9" rx="3" ry="3" width="6" height="285" />
                        <rect x="55" y="42" rx="16" ry="16" width="274" height="216" />
                        <rect x="412" y="113" rx="3" ry="3" width="102" height="7" />
                        <rect x="402" y="91" rx="3" ry="3" width="178" height="6" />
                        <rect x="405" y="139" rx="3" ry="3" width="178" height="6" />
                        <rect x="416" y="162" rx="3" ry="3" width="102" height="7" />
                        <rect x="405" y="189" rx="3" ry="3" width="178" height="6" />
                        <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
                        <rect x="406" y="223" rx="14" ry="14" width="72" height="32" />
                        <rect x="505" y="224" rx="14" ry="14" width="72" height="32" />
                        <rect x="376" y="41" rx="3" ry="3" width="231" height="29" />
                    </content-loader>
                </div>
                <div v-else>
                    <b-row class="mb-3 eventcard">
                        <div class="col-md-12 recipe-img" v-bind:style='{ backgroundImage: "url(" + recipe.images + ")", }'></div>
                        <div class="col-md-12">
                            <div class="font18 mt-3 text-capitalize font-weight-600">
                                {{recipe.name}}

                            </div>
                            <div class="font12">
                                <b-form-rating readonly show-value inline size="sm" v-model="recipe.average_ratings"></b-form-rating>
                            </div>
                            <p class="font12">
                               <span v-html="recipe.storyline"> </span>  
                            </p>

                        </div>
                        <b-col cols="6" class="pb-3">
                            <div class="font14 ">
                                <span><strong>Ingredients:</strong></span>
                                <div v-for="(ing, index) in recipe.ingredients" :key="index">
                                    {{ing.item}}
                                </div>

                            </div>

                        </b-col>
                        <b-col cols="6" class="pb-3">
                            <p class=" font12 ">
                                <span>Origin</span> - {{recipe.origin}}
                            </p>
                            <p class=" font12 ">
                                <span>Get this recipe for</span> - <span class="font-weight-600 culture-primary">
                                    {{recipe.amount ? recipe.amount:''}} {{recipe.amount ?
                                        recipe.currency:'FREE'}}</span>
                            </p>
                            <p class=" font12 ">
                                <span>Cook Time</span> - {{recipe.cook_time}}

                            </p>
                            <p class=" font12 ">
                                <span>Prep Time</span> - {{recipe.prep_time}}
                            </p>

                        </b-col>

                        <b-col cols="12" class="pb-3">
                            <span class="mr-3">Share this recipe</span>
                            <facebook class="mr-2" :title="recipe.name" :url="url" scale="2" />

                            <twitter class="mr-2" :url="url" scale="2" />

                            <whats-app class="mr-2" :url="url" scale="2" />
                            <button v-if="isLoggedIn && recipe.hire_status == 1 && recipe.cook.user_id != currentUser.user_id" v-b-modal="'availability'" class="btn btn-warning btn-below font10">
                                <b-icon font-scale="0.99" icon="person">
                                </b-icon> Hire Chef
                            </button>
                            <button @click="generateRecipe" class="ml-2 btn btn-warning btn-below font10">
                                <b-icon font-scale="0.99" :icon="recipe.fee_type == 'free' || recipe.instructions.length > 0 ? 'arrow-down' : 'cart2'">
                                </b-icon> {{ recipe.fee_type == "free" || recipe.instructions.length > 0 ? 'Download': 'Purchase'}}
                            </button>
                            <router-link target="_blank" v-if="recipe.event" :to="{ name: 'listing-details', params: {id: recipe.event.event_id} }" class="ml-2 btn
                                    btn-warning btn-below font10">
                                <b-icon font-scale="0.99" icon="calendar-2">
                                </b-icon> See Attached Event
                            </router-link>
                        </b-col>
                    </b-row>
                </div>

            </b-col>
        </b-row>
        <b-row class="mobile">
            <b-col cols="12" class="mt-5">
                <div v-if="loading">
                    <content-loader :speed="2" :height="400" :width="700">
                        <rect x="4" y="8" rx="3" ry="3" width="7" height="288" />
                        <rect x="6" y="289" rx="3" ry="3" width="669" height="8" />
                        <rect x="670" y="9" rx="3" ry="3" width="6" height="285" />
                        <rect x="55" y="42" rx="16" ry="16" width="274" height="216" />
                        <rect x="412" y="113" rx="3" ry="3" width="102" height="7" />
                        <rect x="402" y="91" rx="3" ry="3" width="178" height="6" />
                        <rect x="405" y="139" rx="3" ry="3" width="178" height="6" />
                        <rect x="416" y="162" rx="3" ry="3" width="102" height="7" />
                        <rect x="405" y="189" rx="3" ry="3" width="178" height="6" />
                        <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
                        <rect x="406" y="223" rx="14" ry="14" width="72" height="32" />
                        <rect x="505" y="224" rx="14" ry="14" width="72" height="32" />
                        <rect x="376" y="41" rx="3" ry="3" width="231" height="29" />
                    </content-loader>
                </div>
                <div v-else>
                    <b-row class="mb-3 eventcard">
                        <div class="col-md-12 recipe-img" v-bind:style='{ backgroundImage: "url(" + recipe.images + ")", }'></div>
                        <div class="col-md-12">
                            <div class="font14 mt-3 text-capitalize font-weight-600">
                                {{recipe.name}}
                            </div>
                            <div class="font12">
                                <b-form-rating readonly show-value inline size="sm" v-model="recipe.average_ratings"></b-form-rating>
                            </div>
                            <p class="font12">
                                <span v-html="recipe.storyline"> </span>  
                            </p>
                        </div>
                        <b-col cols="12" class="pb-3">
                            <p class=" font12 ">
                                <span>Origin</span> - {{recipe.origin}}
                            </p>
                            <p class=" font12 ">
                                <span>Get this recipe for</span> -<span class="font-weight-600 culture-primary">
                                    {{recipe.amount ? recipe.amount:''}} {{recipe.amount ?
                                        recipe.currency:'FREE'}}</span>
                            </p>
                            <p class=" font12 ">
                                <span>Cook Time</span> - {{recipe.cook_time}}
                            </p>

                        </b-col>
                        <b-col cols="12" class="pb-3">
                            <p class=" font12 ">
                                <span>Prep Time</span> - {{recipe.prep_time}}
                            </p>
                            <div class=" font12 ">
                                <span><strong>Ingredients:</strong></span>
                                <div v-for="(ing, index) in recipe.ingredients" :key="index+ing">
                                    {{ing.item}}
                                </div>
                            </div>

                        </b-col>
                        <b-col cols="12" class="pb-3">
                            <span class="mr-3">Share this recipe</span>
                            <facebook class="mr-2" :title="recipe.name" :url="url" scale="2" />

                            <twitter class="mr-2" :url="url" scale="2" />

                            <whats-app :url="url" scale="2" />
                            <button v-if="recipe.hire_status == 1" v-b-modal="'availability'" class="mt-2 btn btn-warning btn-below font10">
                                <b-icon font-scale="0.99" icon="person">
                                </b-icon> Hire Chef
                            </button>
                            <button @click="generateRecipe" class="mt-2 ml-2 btn btn-warning btn-below font10">
                                <b-icon font-scale="0.99" :icon="recipe.fee_type == 'paid'? 'cart2' : 'arrow-down'">
                                </b-icon> {{ recipe.fee_type == "paid"? 'Purchase': 'Download'}}
                            </button>
                            <router-link target="_blank" v-if="recipe.event" :to="{ name: 'listing-details', params: {id: recipe.event.event_id} }" class="mt-2 ml-2 btn
                                    btn-warning btn-below font10">
                                <b-icon font-scale="0.99" icon="calendar-2">
                                </b-icon> See Attached Event
                            </router-link>

                        </b-col>
                    </b-row>
                </div>

            </b-col>
        </b-row>
    </b-container>
    <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="true" :paginate-elements-by-height="1100" filename="recipePDF" :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" ref="html2Pdf">
        <section slot="pdf-content">
            <RecipePage :name="recipe.name" :origin="recipe.origin" :instructions="recipe.instructions" :prepTime="recipe.prep_time" :ingredients="recipe.ingredients" :cookTime="recipe.cook_time" :storyLine="recipe.storyline" :imgUrl="recipe.images" />
        </section>
    </VueHtml2pdf>
    <b-modal size="lg" id="availability" centered title="Select Availability" hide-footer>
        <form @submit.prevent="proposeDateTime">
            <b-form-group class="mb-4" label-for="">
                <label for="">Select date and time</label>
                <date-range-picker required ref="picker" :date-format="dateFormat" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }" :timePicker="true" :showDropdowns="true" v-model="dateRange">
                    <template v-slot:input="picker" style="min-width: 350px;">
                        {{ picker.startDate }} - {{ picker.endDate }}
                    </template>
                </date-range-picker>
            </b-form-group>
            <b-form-group class=" mt-2 mb-2" label-for="input-1">
                <b-form-checkbox v-model="isVirtual" switch inline class="col-md-12 my-2 mb-3">
                    check this if the address is virtual
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4" label-for="address" v-if="!isVirtual">
                <b-input-group class="">
                    <b-input-group-prepend is-text>
                        <b-icon icon="bookmark"></b-icon>
                    </b-input-group-prepend>
                    <vue-google-autocomplete id="l-map" required ref="address" classname="form-control" placeholder="Enter a physical address or location" v-on:placechanged="getAddressData" v-model="guest_address">
                    </vue-google-autocomplete>
                </b-input-group>
            </b-form-group>
            <b-form-group class=" mb-4" label-for="origin" v-if="isVirtual">
                <b-input-group class="custom-input-group">
                    <b-input-group-prepend is-text>
                        <b-icon icon="link45deg"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="text" required v-model="guest_address" placeholder="Enter virtual link"></b-form-input>
                </b-input-group>
            </b-form-group>

            <b-form-group class="mb-2" label-for="event">
                <button class="btn btn-warning btn-below font12">{{modalbtnText}}</button>
            </b-form-group>
        </form>
    </b-modal>
    <Footer />
</div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import RecipeSidebar from "@/components/RecipeSidebar.vue";
import VueHtml2pdf from 'vue-html2pdf'
import RecipePage from "@/components/Recipe.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete';

import {
    ContentLoader
} from "vue-content-loader";
import {
    Facebook,
    Twitter,
    WhatsApp
} from "vue-socialmedia-share";

import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'recipe-details',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        ContentLoader,
        RecipeSidebar,
        Facebook,
        Twitter,
        WhatsApp,
        Footer,
        DateRangePicker,
        VueHtml2pdf,
        RecipePage,
        VueGoogleAutocomplete

    },
    metaInfo() {
        return {
            title: this.recipe.name,
            meta: [{
                    name: 'description',
                    content: this.recipe.description
                },
                {
                    property: "og:title",
                    content: this.recipe.name
                },
                {
                    property: "og:image",
                    content: this.recipe.images
                },
                {
                    property: 'og:site_name',
                    content: 'Culture Square'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }
    },

    data: function () {
        return {
            headerText: "RECIPES DETAILS",
            subText: "See all the recipe details",
            fadedText: "recipes",
            recipe: {},
            loading: true,
            url: window.location.href,
            dateRange: {
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString()
            },
            modalbtnText: "Propose Time",
            guest_address: "",
            isVirtual: false
        }
    },
    computed: {
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
    },
    mounted() {
        this.getRecepie();
    },
    methods: {
        getAddressData: function (_addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.guest_address = placeResultData.formatted_address;
            }
        },
        generateRecipe() {
            this.recipe.images = `${this.recipe.images}?crossorigin`

            if (this.recipe.fee_type == 'free') {
                this.checkAuth(this.recipe.food_id)
            } else if (this.recipe.fee_type == 'paid' && this.recipe.instructions.length > 0) {
                this.checkAuth(this.recipe.food_id)
            } else {
                this.$router.push({
                    name: 'recipe-pay',
                    params: {
                        recipe: this.recipe,
                        id: this.recipe.food_id
                    }
                })
            }
        },
        openMenu() {
            var slide = document.getElementById('slidmenu')
            if (slide.style.marginLeft === '-347%') {
                slide.style.marginLeft = '-24px'

            } else {
                slide.style.marginLeft = '-347%'
            }
        },
        hideSidemenu() {
            var slide = document.getElementById('slidmenu')
            slide.style.marginLeft = '-347%'
        },

        async getRecepie() {
            const foodId = this.$route.params.id
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/foodlistings/${foodId}`,
                    method: "GET",
                })
                this.loading = false
                this.recipe = resp.data.data

            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async checkAuth(recipe_id) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/recipe/download`,
                    data: {
                        recipe_id: recipe_id
                    },
                    method: "POST",
                })
                if (resp.data.success) this.$refs.html2Pdf.generatePdf()
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        dateFormat(classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        async proposeDateTime() {
            const data = {
                guest_address: this.guest_address,
                guest_id: this.currentUser.user_id,
                proposed_start: this.dateRange.startDate,
                proposed_end: this.dateRange.endDate,
                recipe_id: this.recipe.food_id
            }
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/check-availability`,
                    data: data,
                    method: "POST",
                })
                this.loading = false
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$bvModal.hide('availability')
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        }
    }

}
</script>

<style lang="scss" scoped>
.eventcard {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    border: none !important;
    background: #FCFCFC;
    height: auto;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: auto;
    }
}

.recipe-img {
    height: 18rem;
    border-radius: 16px 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.btn-culture {
    padding: 10px 60px !important;
    line-height: 1.9 !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        line-height: 0.9 !important;
    }
}

.b-icon.bi {
    margin-bottom: 2px !important
}

.bi-search {
    margin-right: 1rem;
}

.btn-box {
    margin: 14px 0
}

.eventcard:hover {
    border: 1px solid #F7B131 !important;
    border-radius: 16px 0;
}

.flex {
    display: flex;
    justify-content: space-between;
}

.btn-below {
    padding: 7px 11px !important
}

.form-control-sm {
    padding: 0.25rem 0 !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.culture-primary span {
    color: #565C63 !important
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: -347%;
    width: 328%;
    top: -2px;
    padding-left: 16px;
    transition: all 0.5s ease-in-out;
}

span.del {
    cursor: pointer;
}

.rating-title {
    font-size: 32px;
    font-weight: bold
}

a {
    color: #565C63
}

.mobile {
    margin-left: 0 !important
}
</style>
